import { Link } from "react-router-dom";

export default function FooterSection() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="container-site py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <h3 className="text-xl font-heading font-bold">Mulebuy.asia</h3>
            <p className="mt-4 text-foreground-100/70 text-sm leading-relaxed max-w-xs">
              Your trusted source for the best Mulebuy Spreadsheet featuring verified sellers, QC guides, and the latest product finds.
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: "ri-twitter-x-line", label: "Twitter" },
                { icon: "ri-instagram-line", label: "Instagram" },
                { icon: "ri-reddit-line", label: "Reddit" },
                { icon: "ri-discord-line", label: "Discord" },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:bg-white/10 hover:text-white transition-colors duration-200"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-100/50 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-foreground-100/70 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/mulebuy-spreadsheet-guide" className="text-sm text-foreground-100/70 hover:text-white transition-colors duration-200">
                  Buying Guide
                </Link>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-100/70 hover:text-white transition-colors duration-200"
                >
                  Kaspreadsheet Main Site
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-100/50 mb-5">Resources</h4>
            <ul className="space-y-3">
              <li>
                <span className="text-sm text-foreground-100/70">Mulebuy Spreadsheet Guide</span>
              </li>
              <li>
                <span className="text-sm text-foreground-100/70">Mulebuy QC Reference</span>
              </li>
              <li>
                <span className="text-sm text-foreground-100/70">Mulebuy Seller Directory</span>
              </li>
              <li>
                <span className="text-sm text-foreground-100/70">Shipping Information</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-foreground-100/50">
            &copy; {new Date().getFullYear()} Mulebuy.asia. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-100/50 hover:text-foreground-100/70 transition-colors duration-200" rel="nofollow">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-foreground-100/50 hover:text-foreground-100/70 transition-colors duration-200" rel="nofollow">
              Terms of Service
            </a>
            <Link to="/mulebuy-spreadsheet-guide" className="text-xs text-foreground-100/50 hover:text-foreground-100/70 transition-colors duration-200">
              Buying Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}